var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.allowedNetworks,"hide-selected":"","label":"Skill Networks","placeholder":"Search by name of skills network...","prepend-icon":"mdi-briefcase","clearable":"","auto-select-first":"","color":"secondary"},model:{value:(_vm.network),callback:function ($$v) {_vm.network=$$v},expression:"network"}})
}
var staticRenderFns = []

export { render, staticRenderFns }